<template>
    <div>
      <div class="container-form px-3 py-3" v-for="rec in recommendations">
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Datos Personales</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap mt-2>
              <v-flex xs12 lg4 px-1>
                <h3>Nombre completo</h3>
                {{ rec.name }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Celular</h3>
                {{ rec.cellphone }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Email</h3>
                {{ rec.email }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Usted es?</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Egresado')">
              <v-flex xs12 lg3 px-1>
                <h3>Egresado</h3>
              </v-flex>
              <v-flex xs12 lg9 px-1>
                <strong>Año de Egresado:</strong> {{ rec.graduate_year }}
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Exalumno')">
              <v-flex xs12 lg3 px-1>
                <h3>Exalumno</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Papa del colegio')">
              <v-flex xs12 lg3 px-1>
                <h3>Papá del colegio</h3>
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Hijo:</strong> {{ rec.child_name }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Grado:</strong> {{ rec.child_grade }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Código de familia:</strong> {{ rec.recomendation_family }}
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Papa de un exalumno')">
              <v-flex xs12 lg3 px-1>
                <h3>Papá de un exalumno</h3>
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Hijo:</strong> {{ rec.ex_name }}
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Familia pasiva')">
              <v-flex xs12 lg3 px-1>
                <h3>Familia pasiva</h3>
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Hijo:</strong> {{ rec.passive_name }}
              </v-flex>
              <v-flex xs12 lg3 px-1>
                <strong>Año en que ingresará:</strong> {{ rec.child_year }}
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="rec.recommendation_is.includes('Otro')">
              <v-flex xs12 lg3 px-1>
                <h3>Otro</h3>
              </v-flex>
              <v-flex xs12 lg9 px-1>
                {{ rec.other_text }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Sobre la Familia</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap mt-2>
              <v-flex xs12 lg4 px-1>
                <h3>Acudiente</h3>
                {{ guardianName(rec.guardian) }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Hace cuanto lo conoce</h3>
                {{ rec.known_how_long }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Tipo de Relación</h3>
                {{ rec.relation }}
              </v-flex>
              <v-flex xs12 lg6 px-1>
                <h3>En una escala de 1 a 10, ¿qué tanto conoce al acudiente?</h3>
                {{ rec.know_how_much }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card flat class="container-form-inner mb-3">
          <v-card-title>
            <h2 class="font-weight-regular">Confirmación Laboral del Acudiente</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap mt-2>
              <v-flex xs12 lg4 px-1>
                <h3>La siguiente información es correcta</h3>
                {{ rec.correct_info }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Ocupación</h3>
                {{ guardianOcupation(rec.guardian) }}
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <h3>Empleador</h3>
                {{ guardianCompany(rec.guardian) }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>Información adicional del acudiente</h3>
                {{ rec.guardian_info }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card flat class="container-form-inner">
          <v-card-title>
            <h2 class="font-weight-regular">Preguntas</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap mt-2>
              <v-flex xs12 lg12 px-1>
                <h3>¿Usted se sentiría tranquilo si el hijo(a) de la familia a la que está recomendando más adelante forma parte de su familia?</h3>
                {{ rec.part_family }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>¿Usted permitiría que sus hijos fueran de vacaciones con la familia que está recomendando?</h3>
                {{ rec.vacation_family }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>¿La familia a la que está recomendando, participa en actividades que son legal y socialmente aceptadas?</h3>
                {{ rec.legal_activities }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>¿Cree usted que la familia que recomienda puede asumir cumplidamente las obligaciones económicas?</h3>
                {{ rec.economic_obligations }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>¿Conoce de alguna situación de carácter penal de alguno de los miembros de la familia aspirante y su entorno cercano?</h3>
                {{ rec.criminal_situation }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>¿Tiene usted alguna razón para considerar que esta familia no debería hacer parte de la comunidad de The Columbus School?</h3>
                {{ rec.not_columbus }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>La familia aspirante a la que recomienda, ¿tiene familiares en el Colegio?</h3>
                {{ rec.family_relatives }}
              </v-flex>
              <v-flex xs12 lg12 px-1 v-if="rec.family_relatives === 'Si'">
                <h3>Escriba los nombres de los familiares, la relación que tienen con el aspirante y grado en el que se encuentra matriculado el familiar.</h3>
                {{ rec.info_relatives }}
              </v-flex>
              <v-flex xs12 lg12 px-1>
                <h3>Use este espacio si desea agregar información sobre aspectos relevantes de la familia que está recomendando.</h3>
                {{ rec.family_info }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </div>
</template>

<script>
export default {
  name: 'admissions-recommendations',
  props: {
    recommendations: {
      type: Array,
      required: true
    },
    family_id: {
      type: String,
    }
  },
  data() {
    return {}
  },
  methods: {
    guardianName (value) {
      if (value == 'guardian1') {
        return this.recommendations[0].guardian1_first_name + " " + this.recommendations[0].guardian1_last_name
      } else {
        return this.recommendations[0].guardian2_first_name + " " + this.recommendations[0].guardian2_last_name
      }
    },
    guardianOcupation (value) {
      if (value == 'guardian1') {
        return this.recommendations[0].guardian1_ocupation
      } else {
        return this.recommendations[0].guardian2_ocupation
      }
    },
    guardianCompany (value) {
      if (value == 'guardian1') {
        return this.recommendations[0].guardian1_company
      } else {
        return this.recommendations[0].guardian2_company
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .container-form{
    background: #6198c8;
    border-bottom: solid 2px #000;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/recommendations.vue